import React, { Component } from 'react';
import { connect } from 'react-redux';
import {  Row, Col, Form, Input,  FormFeedback, FormGroup } from 'reactstrap';
import { withRouter } from 'react-router';
import { customerDetailAction } from "../../../actions";
import swal from 'sweetalert';
import { show, hide } from 'redux-modal';
import { handleCompanyNameValidation } from './CompanyNameValidation'
class UpdateCompanyName extends Component {
    constructor(props) {
        super(props)
        this.state = {
            formData: {
                id: '',
                company_name: ''
            },
            errors: {},
        }
        this.handleChange = this.handleChange.bind(this)
        this.handelUpdateCompanyName = this.handelUpdateCompanyName.bind(this)
        this.afterAction = this.afterAction.bind(this)
        this.toggle = this.toggle.bind(this)
        this.handelCansel = this.handelCansel.bind(this)
    }
    toggle() {
        const { onClose } = this.props
        onClose()
    }


    handleChange(e) {
        e.preventDefault()
        const { formData } = this.state
        const { name, value } = e.target;

        if (name === "company_name") {
            let regex_allowed = /^[a-zA-Z0-9 .,]+$/
            if (value.length && regex_allowed.test(value) === false) {
                return false;
            }
        }


        formData[name] = value;

        this.setState({ formData })
        // const result = handleCompanyNameValidation()
        // this.setState({ errors: result.errors })
    }

    handelCansel() {
        const { dispatch } = this.props;
        dispatch(hide("bootstrap"))
    }
    afterAction() {
        const { dispatch, getCustomerList } = this.props;
        dispatch(hide("bootstrap"))
        getCustomerList()
    }

    handelUpdateCompanyName(e) {
        e.preventDefault();
        const { formData } = this.state;
        const { dispatch } = this.props;

        const result = handleCompanyNameValidation(formData)
        this.setState({ errors: result.errors })
            if (result.formIsValid) {
                swal({
                    title: "Are you sure ?",
                    text: "Do you want to update company name?",
                    icon: "warning",
                    buttons: true,
                    dangerMode: true,
                }).then((confirm) => {
                    if (confirm) {
                        formData.type = 'company_name'
                        dispatch(customerDetailAction.updateCustomerDetilEmail(formData, this));
                    }
                })
            }

        // else {
        //     dispatch(notify({ position: "tc", dismissible: false, message: '', status: "error" }))

        // }

    }
    componentDidMount() {
        const { customerDetail } = this.props;
        let { formData } = this.state;
        if (customerDetail) {
            formData.id = customerDetail.id
            formData.company_name = customerDetail.company_name ? customerDetail.company_name : ''
            this.setState({ formData })
        }

    }
    render() {
        const { errors, formData } = this.state
        return (

            <React.Fragment>
                <Form autocomplete="off">
                    <Row>
                        <Col md="12">
                            <FormGroup >
                            <Input placeholder="Company Name" onChange={this.handleChange} value={formData.company_name} name="company_name" maxLength="100" />
                            <FormFeedback>
                                {errors[`company_name`] && errors[`company_name`]}
                            </FormFeedback>

                            </FormGroup>
                        </Col>
                    </Row><hr />
                    <button className="btn btn-secondary btn-sm pull-right" onClick={this.handelCansel} style={{'marginLeft':'10px'}} > Cancel </button>
                    <button type="button" onClick={this.handelUpdateCompanyName} className="btn btn-primary btn-sm pull-right"  > Update </button>
                </Form>
            </React.Fragment>

        )
    }
}

function mapStateToProps(state) {
    const { loading, data, customerDetail } = state.getCustomerStatusData
    return {
        loading,
        data,
        customerDetail
    }
}

const connectedUpdateCompanyName = withRouter(connect(mapStateToProps)(UpdateCompanyName))
export { connectedUpdateCompanyName as UpdateCompanyName }